import gql from 'graphql-tag';

import { companyFragment } from '~/shared/graphql-queries/companies/index';

export default gql`
  mutation createOneCompanyMutation($record: CreateOneCompanyInput!) {
    createOneCompanyMutation(record: $record) {
      recordId
      record {
        ...CompanyFragment
      }
      message
      title
    }
  }
  ${companyFragment}
`;
